import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {  MerchantProfileSelectItem, MerchantProfile, UniversityPerson } from '../models';

@Injectable()
export class MerchantProfileService {
    private readonly apiUrl = `api/merchantprofile`;
    constructor(private readonly httpClient: HttpClient) { }

    getAllMerchantProfiles(): Observable<MerchantProfile[]> {
        return this.httpClient.get<MerchantProfile[]>(`${this.apiUrl}/All`);
    }

    getAllMerchantProfilesForSelection(): Observable<MerchantProfileSelectItem[]> {
        return this.httpClient.get<MerchantProfileSelectItem[]>(`${this.apiUrl}/Select`);
    }

    getMerchantProfile(id: number): Observable<MerchantProfile> {
        return this.httpClient.get<MerchantProfile>(`${this.apiUrl}/${id}`);
    }

    isMerchantProfileNameUnique(name: string, id: number = null): Observable<boolean> {
        return this.httpClient.post<boolean>(`${this.apiUrl}/Name/Unique`, { merchantProfileId: id, merchantProfileName: name });
    }

    create(request: any): Observable<number> {
        return this.httpClient.post<number>(`${this.apiUrl}`, request);
    }

    update(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Update/${id}`, request);
    }

    addMerchantAccessUsers(request: any): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/AddMerchantAccessUsers`, request);
    }

    removeMerchantAccessUsers(merchantProfile: MerchantProfile, merchantAccessUser: UniversityPerson): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/RemoveMerchantAccessUsers`, { merchantProfileId: merchantProfile.id, univid: merchantAccessUser.univId });
    }
}